<template>
  <div>
    <div v-show="!noCauseDialog">
      <Navbar :appTitle="$route.query.type == 'edit' ? '编辑报工' : '新建报工'" @ClickRight="$router.push('/application')" />
      <div class="search-content wrap-apply" :style="{
        top: GLOBAL.currentEnvironment ? '0' : '',
        paddingBottom: GLOBAL.currentEnvironment ? '132px' : '',
      }">
        <van-cell-group style="margin-top:20px">
          <p class="label required FormTit"><span></span>工单编号</p>
          <scanInput v-if="showScan" ref="scanInput" :columns="orderList" placeholder="请选择/扫码"
            @changeScan="changeScan" />
          <van-field v-else readonly v-model="buildForm.orderCode" placeholder="请选择/扫码" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>生产物品</p>
          <van-field readonly v-model="buildForm.goodsName" placeholder="根据工单带入" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label required FormTit"><span></span>工序</p>
          <scanInput v-if="showScan" ref="scanInput2" :columns="processList" placeholder="请选择/扫码"
            @changeScan="changeScan2" />
          <van-field v-else readonly v-model="buildForm.processesName" placeholder="请选择/扫码" />
          <div class="bottomLine" style="margin-top:2px"></div>
        </van-cell-group>

        <van-cell-group>
          <p class="label FormTit"><span></span>计划数</p>
          <van-field readonly v-model="buildForm.planProduceNum" placeholder="根据工序带入" />
          <div class="bottomLine"></div>
        </van-cell-group>

        <van-cell-group>
          <p class="label required FormTit"><span></span>操作人</p>

          <scanInputContact v-if="showScan" :columns="processList" ref="scanInput3" placeholder="请选择/扫码"
            @changeScan="changeScan3" :userIdText="buildForm.userIdText" @contactFn="handleChooseOperator" />
          <div class="bottomLine"></div>
        </van-cell-group>

        <van-cell-group>
          <p class="label required FormTit"><span></span>合格数</p>
          <van-field :value="buildForm.qualifiedNum" type="number" placeholder="请输入" @input="qualifiedInput" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label required FormTit"><span></span>不合格数</p>
          <van-field :value="buildForm.unqualifiedNum" type="number" placeholder="请输入" @input="unqualifiedInput" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label  FormTit"><span></span>不合格原因</p>
          <van-field readonly v-model="buildForm.unqualifiedNotes" placeholder="请选择"
            @click="fillUnqualifiedItem(buildForm)" />
          <div class="bottomLine"></div>
        </van-cell-group>

        <van-cell-group>
          <p class="label required FormTit"><span></span>报工时间</p>
          <van-field is-link readonly name="picker" v-model="buildForm.reportTime" @click="timePickShow = true"
            placeholder="请选择">
          </van-field>
          <div class="bottomLine"></div>
        </van-cell-group>

        <van-cell-group>
          <p class="label  FormTit"><span></span>附件</p>
          <file-selector ref="fileSelect" :maxCount="3" :fileIds="buildForm.attachment"
            @fileChange="fileChange"></file-selector>
        </van-cell-group>

        <div class="jiange-line"></div>

        <van-cell-group>
          <p class="label otherText">自定义信息</p>
          <div class="bottomLine"></div>
          <div v-for="(p, index) in formTypeExtendedFields" :key="index">
            <p class="label FormTit" :class="{ required: p.fieldMust == 2 }"><span></span>{{ p.fieldName }}</p>
            <!-- :type="p.fieldType == 3 || p.fieldType == 4 ? 'number':p.fieldType == 1?'textarea' : 'text'" -->
            <van-field :placeholder="p.placeholder" v-model="buildForm.extDataJson[p.fieldKey]"
              :readonly="p.fieldMust == 1"
              :type="p.fieldType == 3 || p.fieldType == 4 ? 'number' : p.fieldType == 2 ? 'textarea' : 'text'"
              :maxlength="p.fieldType == 1 ? 50 : '-'"
              :formatter="(value) => onInput(value, p.fieldLength, p.fieldType)" />
            <div class="bottomLine"></div>
          </div>
        </van-cell-group>
        <div class="search-bottoms">
          <van-button @click="btnConfirm(true)" block color="#f6f6f6" :loading="subLoading" loading-text="加载中...">
            <div style="color: #333;font-weight: 400;">继续报工</div>
          </van-button>
          <van-button style="margin-left: 10px;" @click="btnConfirm(null, true)" block color="#1890ff"
            :loading="subLoading" loading-text="加载中...">
            <div style="color: #fff;">
              {{ subBtnText }}
            </div>
          </van-button>
        </div>
      </div>

      <!--选择报工时间 -->
      <van-popup v-model="timePickShow" position="bottom">
        <van-datetime-picker @confirm="confirmPick" v-model="happenTime" @cancel="cancelPick" type="datetime"
          title="报工时间" :formatter="formatter" />
      </van-popup>

      <!-- 操作按钮弹窗-->
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker show-toolbar :columns="processList" @cancel="showPicker = false" @confirm="onConfirm"
          value-key="key" />
      </van-popup>

      <!--操作人组件-->
      <contact-pickers :visible="userSelectVisible" @closePicker="userSelectVisible = false" @confirm="selectOperator">
      </contact-pickers>
    </div>

    <!-- 不合格原因组件 -->
    <noCause ref="noCaseComp" :listData="buildForm.produceOrderReportWorkNonconformityDetailVoList"
      v-show="noCauseDialog" @noCauseConfirm="noCauseConfirm" @noCauseCancel="noCauseCancel">
    </noCause>

    <PDAsao ref="pda" @changeScan="changeScan1" />
  </div>
</template>
<script>
import moment from "moment"
import Navbar from "@/components/navBar/navBar_right"
import scanInput from "@/components/scanCode/scanInput"
import scanInputContact from "@/components/scanCode/scanInputContact"
import upload from "@/components/upload/upload"
import VanFieldSelectPicker from "@/components/ActionSheet/VanFieldSelectPicker"
import fileSelector from "@/components/fileSelector.vue"
import Examine from "@/components/examine"
import {
  processByBatchId,
  productionReportingAdd,
  productionTaskProcessMessage,
  workOrderDetailQueryById,
  workOrderList,
  scheduleById,
  produceOrderReportWorkQueryById,
  produceOrderReportWorkEdit,
  produceOrderReportWorkWorkbench,
  taskListApi,
  produceOrderReportWorkWorkbenchProduce,
} from "@/api/productionApply"
import { formTypeExtendedFieldList } from "@/api/mobile"
import ContactPickers from "@/components/choiceuse/ContactPickers.vue"
import noCause from "@/views/workManagement/productTask/noCause.vue"
import { Tip as Tips } from "@/utils"
import { getAction } from "@/api/manage"
import PDAsao from "./components/PDAsao.vue"
import FileSelector from "../../../components/fileSelector.vue"
import { clearNoNumWithFour } from "@/utils/util"

export default {
  name: "newOutsourcingReport",
  components: {
    PDAsao,
    ContactPickers,
    fileSelector,
    upload,
    VanFieldSelectPicker,
    Navbar,
    scanInput,
    Examine,
    noCause,
    scanInputContact,
    FileSelector,
  },
  data() {
    return {
      subBtnText: "提交",
      subLoading: false,
      userIdList: [],
      realnameList: [],
      userIdScanList: [],
      detailInfo: {},
      sequentially: false,
      formTypeExtendedFields: [],
      happenTime: new Date(),
      timePickShow: false,
      noCauseDialog: false,
      showPicker: false,
      userSelectVisible: false, // 操作人选择组件
      buildForm: {
        unqualifiedNum: 0,
        qualifiedNum: "",
        extDataJson: {},
        userId: "",
      },
      unqualifiedItemModal: false, // 填写不合格项数量
      unqualifiedItemList: [], // 不合格项列表
      orderList: [],
      columns: [],
      processList: [],
      showScan: false,
      // 可报工数
      reportWorkNum: 0,
      // 编辑时,提交的总数
      editTotal: 0,
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.showPeopleSlect) {
      this.$refs.examine.closePicker()
      next(false)
    } else {
      next()
    }
  },
  async created() {
    // 获取出入库自定义表单字段;
    formTypeExtendedFieldList({ formType: 4 }).then((res) => {
      if (res.code == 200 && res.result) {
        this.formTypeExtendedFields = res.result
      }
    })
    this.buildForm.reportTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    this.getInitData()

    this.showScan = true

    // 扫工单码进入
    if (this.$route.query.formPage == "scanCode" && this.$route.query.code) {
      this.changeScan({ code: this.$route.query.code }, "scan")
    }
    if (this.$route.query.codeType == "productTask") {
      this.changeScan2({ code: this.$route.query.code }, "scan")
    }

    if (this.$route.query.codeType === "number") {
      this.changeScan4({ code: this.$route.query.code }, "scan")
    }

    if (this.$route.query.codeType === "userid") {
      this.changeScan5({ code: this.$route.query.code }, "scan")
    }
  },
  methods: {
    qualifiedInput(value) {
      if (value.startsWith("-")) {
        this.$toast("输入的数字不能是负数！")
        return
      }
      // 检查整数部分是否超过12位
      const integerPart = value.split(".")[0]
      if (integerPart.length > 12) {
        this.$toast("整数最多输入12位!")
        return
      }

      // 检查小数部分是否超过4位
      const decimalPart = value.split(".")[1]
      if (decimalPart && decimalPart.length > 4) {
        this.$toast("小数最多输入4位!")
        return
      }

      // 合法输入，赋值
      this.buildForm.qualifiedNum = value
    },
    unqualifiedInput(value) {
      if (value.startsWith("-")) {
        this.$toast("输入的数字不能是负数！")
        return
      }
      // 检查整数部分是否超过12位
      const integerPart = value.split(".")[0]
      if (integerPart.length > 12) {
        this.$toast("整数最多输入12位!")
        return
      }

      // 检查小数部分是否超过4位
      const decimalPart = value.split(".")[1]
      if (decimalPart && decimalPart.length > 4) {
        this.$toast("小数最多输入4位!")
        return
      }

      this.buildForm.unqualifiedNum = value
    },
    // 红外扫码
    changeScan1(v, flag) {
      console.log(v, "vvvvvv")
      let EntityType = v.EntityType
      let userid = v.userid
      if (v.EntityType === "workOrder") {
        // 扫码之后清空下方数据
        this.processList = [] // 工单编号有变化时清空工序字段的内容
        this.buildForm.taskId = undefined
        this.buildForm.qualifiedNum = 0
        //工单码
        workOrderDetailQueryById({ id: v.id }).then((res) => {
          if (res.code == 200) {
            console.log("res.result", res.result)
            // 判断工单是否为“生产中”状态
            // 若判断为是，则把工单编号回显到当前表单。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
            if (res.result.orderStatus == 1) {
              this.buildForm.orderCode = res.result.orderCode
              this.buildForm.taskId = res.result.taskId
              this.buildForm.goodsName =
                res.result.serialNumber + "|" + res.result.serialName + "|" + (res.result.serialSpecifications || "")
              this.$refs.scanInput.formData.key = res.result.orderCode //回显工单
              this.$refs.scanInput.formData.value = res.result.taskId //回显工单
              this.$forceUpdate()
              workOrderList({
                pageNo: 1,
                pageSize: 9999,
                orderCode: this.buildForm.orderCode,
              }).then((res) => {
                if (res.code == 200) {
                  this.buildForm.goodsName =
                    res.result.records[0].serialNumber +
                    " | " +
                    res.result.records[0].serialName +
                    " | " +
                    (res.result.records[0].serialSpecifications || "")

                  this.processList = res.result.records[0].produceOrderTaskVo.map((item) => {
                    return {
                      label: item.processesName,
                      key: item.processesName,
                      value: item.processesId,
                      taskId: item.taskId,
                      planProduceNum: item.planProduceNum,
                    }
                  })
                }
              })
            } else {
              this.buildForm.orderCode = ""
              this.$toast("工单状态不正确")
            }
          } else {
            this.$toast(res.message)
          }
        })
      } else if (EntityType === "productTask") {
        //任务二维码
        // 判断当前生产任务对应的生产工单状态是否为“生产中”
        // 若判断为是，则把工单编号、工序进行回显，且把对应的可报工数回显到合格数字段。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
        this.processList = [] // 工单编号有变化时清空工序字段的内容
        this.buildForm.taskId = undefined
        this.buildForm.qualifiedNum = 0
        produceOrderReportWorkWorkbenchProduce({
          id: v.id,
        }).then((res) => {
          if (res.code == 200) {
            console.log("res.result", res.result)
            // 判断工单是否为“生产中”状态
            // 若判断为是，则把工单编号回显到当前表单。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
            if (res.result.orderStatus == 1) {
              this.buildForm.orderCode = res.result.orderCode
              this.buildForm.taskId = res.result.id
              // this.$toast(res.result.id)
              this.$refs.scanInput.formData.key = res.result.orderCode //回显工单
              this.$refs.scanInput.formData.value = res.result.id //回显工单
              workOrderList({
                pageNo: 1,
                pageSize: 9999,
                orderCode: this.buildForm.orderCode,
              }).then((res) => {
                if (res.code == 200) {
                  this.buildForm.goodsName =
                    res.result.records[0].serialNumber +
                    " | " +
                    res.result.records[0].serialName +
                    " | " +
                    (res.result.records[0].serialSpecifications || "")

                  this.processList = res.result.records[0].produceOrderTaskVo.map((item) => {
                    return {
                      label: item.processesName,
                      key: item.processesName,
                      value: item.processesId,
                      taskId: item.taskId,
                    }
                  })
                }
              })
            } else {
              this.buildForm.orderCode = ""
              this.$toast("工单状态不正确")
            }
          } else {
            this.$toast(res.message)
          }
        })
      } else if (v >= 0) {
        //数字条码
        // 若扫到数字条码，则把数字条码回显到合格数框，多次扫数字条码则自动拼接。
        // this.$toast(v)
        if (this.buildForm.qualifiedNum > 0) {
          let addStr = v + ""
          this.buildForm.qualifiedNum = this.buildForm.qualifiedNum + addStr
        } else {
          this.buildForm.qualifiedNum = v + ""
        }
        this.buildForm.qualifiedNum = this.buildForm.qualifiedNum.substring(0, 9)
      } else if (EntityType === "printTask" && userid) {
        //用户二维码
        // 扫用户二维码，则把用户回显到操作人字段，扫一个用户二维码则回显一个，多个姓名之间用“，”隔开。
        // 若扫到重复的用户二维码则toast提示“该用户已存在”。
        let users = this.buildForm.userId.split(",")
        if (!users.includes(userid) && this.buildForm.userId) {
          // this.buildForm.userId = this.buildForm.userId + ',' + v.userid
          this.$refs.scanInput3.formData.key = userid
          this.$refs.scanInput3.formData.value = userid
          getAction("/sys/user/queryById", { id: userid }).then((res) => {
            if (res.code == 200) {
              this.realnameList.push(res.result.realname)
              this.userIdList.push(res.result.id)
              this.buildForm.userIdText = this.realnameList.join(",")
              this.buildForm.userId = this.userIdList.join(",")
              this.$forceUpdate()
            }
          })
        } else if (!users.includes(userid) && !this.buildForm.userId) {
          // this.buildForm.userId = v.userid
          getAction("/sys/user/queryById", { id: userid }).then((res) => {
            if (res.code == 200) {
              this.realnameList.push(res.result.realname)
              this.userIdList.push(res.result.id)
              this.buildForm.userIdText = this.realnameList.join(",")
              this.buildForm.userId = this.userIdList.join(",")
              this.$forceUpdate()
            }
          })
        } else {
          this.$toast("该用户已存在")
        }
      } else if (!EntityType) {
        Tips.error("请扫正确的二维码")
      }
    },
    onInput(event, digitCount, fieldType) {
      let value = event + ""
      if (fieldType == 3 || fieldType == 4) {
        // 截断小数点后超过4位的部分
        if (value.includes(".")) {
          let parts = value.split(".")
          if (parts[1].length > 4) {
            value = parts[0] + "." + parts[1].substring(0, 4)
          }
        } else {
          value = event
        }
        // 最大可以输入值
        if (digitCount <= 0) {
          throw new Error("Digit count must be a positive integer.")
        }
        let maxValue = Math.pow(10, digitCount) - 1 + 0.9999
        if (value > maxValue) {
          value = maxValue
          this.$toast("输入值超过允许输入最大值，已取值最大值")
        }
      }

      return value
    },
    clearNoNumTwo(value, type, length) {
      if (type != 3 && type != 4) {
        return value
      } else {
        return value.replace(/[^\d]/g, "")
      }
    },
    formatter(type, val) {
      console.log(type)
      if (type === "year") {
        return val + "年"
      }
      if (type === "month") {
        return val + "月"
      }
      if (type === "day") {
        return val + "日"
      }
      if (type === "hour") {
        return val + "时"
      }
      if (type === "minute") {
        return val + "分"
      }
      if (type === "second") {
        return val + "秒"
      }

      return val
    },

    // 确定选择时间
    confirmPick(date) {
      this.buildForm.reportTime = moment(date).format("YYYY-MM-DD HH:mm:ss")
      this.timePickShow = false
    },
    // 取消选择时间
    cancelPick() {
      this.timePickShow = false
    },
    noCauseConfirm(list, total) {
      this.noCauseDialog = false
      this.buildForm.unqualifiedNotes = list.map((item) => item.nonconformityDescribe + ":" + item.num).join(",")
      this.buildForm.produceOrderReportWorkNonconformityDetail = list.map((item) => {
        return {
          nonconformityNum: item.num,
          nonconformityId: item.id,
        }
      })
      this.$forceUpdate()
    },
    noCauseCancel() {
      this.noCauseDialog = false
    },
    // 根据批次id获取对应批次下的工序
    getBatchList(id) {
      processByBatchId({ id }).then((res) => {
        let processList = res.result
        //   找到sort最大值的工序，根据工序id查询对应工单的信息回填
        // 使用reduce方法查找最大排序值的项
        let maxItem = processList.reduce(function (prev, current) {
          return prev.sort > current.sort ? prev : current
        })
        console.log(maxItem)
        this.buildForm.processName = maxItem.processesName
        this.getOrderInfo(maxItem.id)
      })
    },
    getOrderInfo(id) {
      productionTaskProcessMessage({ id }).then((rst) => {
        console.log(rst)
        this.buildForm.orderId = rst.result.orderId
        this.buildForm.orderCode = rst.result.orderCode
        this.buildForm.goodsName = rst.result.goodsName + "-" + rst.result.goodsCode
        this.buildForm.orderCode = rst.result.orderCode
        this.buildForm.processName = rst.result.processesCode
        this.buildForm.goodsName = rst.result.goodsName + "-" + rst.result.goodsCode
        this.buildForm.orderId = rst.result.id
        this.buildForm.goodsId = rst.result.goodsId
        this.buildForm.goodsBasicUnit = rst.result.goodsBasicUnit
        this.processList = rst.result.processList.map((item) => {
          return {
            label: item.processesName,
            key: item.processesName,
            value: item.id,
            planProduceNum: item.planProduceNum,
          }
        })
      })
    },
    fillUnqualifiedItem() {
      this.noCauseDialog = true
      this.$refs.noCaseComp.initData(this.detailInfo.produceOrderReportWorkNonconformityDetailVoList || [])
    },
    getValue(query) {
      this.buildForm.unqualifiedReason = query.sum2
      this.buildForm.unqualifiedDtos = query.unqualifiedList.map((item) => {
        return {
          id: item.id,
          num: item.num,
        }
      })
    },
    onConfirm(a, b) {
      console.log(a, b, "ab")
      if (typeof a == "undefined") {
        this.showPicker = false
        return
      }
      this.buildForm.processId = a.value
      this.buildForm.processName = a.key
      this.showPicker = false
    },
    handleChooseOperator(index, item) {
      this.currentIndex = index
      this.userSelectVisible = true
    },
    confirmOperator(v) {
      console.log(v)
      if (!v) {
        console.log(v)
        this.buildForm.userId = ""
        this.buildForm.userIdText = ""
        this.$forceUpdate()
      } else {
        console.log(2)
        this.buildForm.userId = v
        this.buildForm.userIdText = v.join(",")
      }
    },

    selectOperator(val, selectedList) {
      console.log(val, selectedList)
      this.userSelectVisible = false
      if (selectedList.length) {
        this.buildForm.userId = val
        this.buildForm.userIdText = selectedList.map((item) => item.realname).join(",")
      } else {
        this.buildForm.userId = ""
        this.buildForm.userIdText = ""
      }
    },
    //页面加载请求数据
    async getInitData() {
      const that = this
      const WorkOrderRes = await workOrderList({
        orderStatus: 1,
        pageNo: 1,
        pageSize: 100000,
      })
      if (WorkOrderRes && WorkOrderRes.code == 200) {
        this.orderList = WorkOrderRes.result.records.map((item) => {
          return {
            key: item.orderCode,
            value: item.id,
          }
        })

        if (this.$route.query.type == "edit") {
          produceOrderReportWorkQueryById({
            id: this.$route.query.item.id,
          }).then((res) => {
            if (res.code == 200) {
              this.detailInfo = res.result
              this.buildForm.planProduceNum = res.result.planProduceNum
              this.formTypeExtendedFields.forEach((item, j) => {
                this.buildForm.extDataJson[item.fieldKey] = res.result.extDataJson[item.fieldKey]
              })

              this.buildForm.orderId = res.result.orderId
              this.buildForm.orderCode = res.result.orderCode
              this.$refs.scanInput.formData.value = res.result.orderId //回显工单
              this.$refs.scanInput.formData.key = res.result.orderCode //回显工单
              //回显物料
              this.buildForm.goodsName =
                res.result.serialNumber +
                " | " +
                res.result.serialName +
                " | " +
                (res.result.serialSpecifications || "")

              //  回显操作人
              this.buildForm.userIdText = res.result.userText
              this.buildForm.userId = res.result.userId

              // 回显合格数
              this.buildForm.qualifiedNum = res.result.qualifiedNum

              // 回显不合格数
              this.buildForm.unqualifiedNum = res.result.unqualifiedNum

              // 回显报工时间
              this.buildForm.reportTime = res.result.reportTime

              // 回显不合格原因
              this.buildForm.unqualifiedNotes = res.result.nonconformityDescribe

              this.editTotal = res.result.reportNum

              scheduleById({ id: res.result.taskId }).then((res) => {
                if (res.code == 200) {
                  this.reportWorkNum = res.result.reportWorkNum
                }
              })

              // 获取工序列表
              workOrderList({
                pageNo: 1,
                pageSize: 9999,
                orderCode: this.buildForm.orderCode,
              }).then((res2) => {
                if (res2.code == 200) {
                  this.processList = res2.result.records[0].produceOrderTaskVo.map((item) => {
                    return {
                      label: item.processesName,
                      key: item.processesName,
                      value: item.processesId,
                      taskId: item.taskId,
                      planProduceNum: item.planProduceNum,
                    }
                  })
                  this.$refs.scanInput2.formData.value = res.result.processesId //回显工序
                  this.$refs.scanInput2.formData.key = res.result.processesName //回显工序
                }
              })

              this.buildForm.processesId = res.result.processesId
              this.buildForm.processesName = res.result.processesName
              this.buildForm.taskId = res.result.taskId
              this.buildForm.attachment = res.result.attachment

              this.$refs.scanInput.showPicker = true
              this.$refs.scanInput.showPicker = false
              this.$refs.scanInput2.showPicker = true
              this.$refs.scanInput2.showPicker = false
              this.$forceUpdate()
            } else {
              this.$toast(res.message)
            }
          })
        }
      }
    },

    changeScan(v, opratorType) {
      console.log(v, opratorType, "获取扫码组件数据")
      //value是下拉选择后值,code是扫码获得的值，根据qrcode判断是否隐藏当前页面只显示相机页
      if (opratorType == "select" && this.buildForm.orderId != v.value) {
        this.buildForm.orderId = v.value
        this.buildForm.orderCode = v.key || "-"

        this.$refs.scanInput2.formData.value = undefined
        this.$refs.scanInput2.formData.key = undefined
        this.buildForm.processesId = ""
        this.buildForm.processesName = ""
        this.buildForm.taskId = ""

        workOrderList({
          pageNo: 1,
          pageSize: 9999,
          orderCode: this.buildForm.orderCode,
        }).then((res) => {
          if (res.code == 200) {
            this.buildForm.goodsName =
              res.result.records[0].serialNumber +
              " | " +
              res.result.records[0].serialName +
              " | " +
              (res.result.records[0].serialSpecifications || "")

            this.processList = res.result.records[0].produceOrderTaskVo.map((item) => {
              return {
                label: item.processesName,
                key: item.processesName,
                value: item.processesId,
                taskId: item.taskId,
                planProduceNum: item.planProduceNum,
              }
            })
          }
        })
      }
      if (opratorType == "scan") {
        console.log(v.code)
        if (v.code.EntityType !== "workOrder") {
          this.$toast("请扫正确二维码")
          return
        }
        let obj = {
          id: v.code.id, //
        }
        workOrderList(obj).then((res) => {
          if (res.code == 200) {
            if (res.result.records[0].orderStatus != 1) {
              this.$toast("工单状态不正确")
              return
            }
            this.buildForm.orderId = res.result.records[0].orderId
            this.buildForm.orderCode = res.result.records[0].orderCode

            this.$refs.scanInput2.formData.value = undefined
            this.$refs.scanInput2.formData.key = undefined

            this.$refs.scanInput.formData.value = res.result.records[0].orderId
            this.$refs.scanInput.formData.key = res.result.records[0].orderCode
            this.$refs.scanInput.showPicker = true
            this.$refs.scanInput.showPicker = false
            this.buildForm.goodsName =
              res.result.records[0].serialNumber +
              " | " +
              res.result.records[0].serialName +
              " | " +
              (res.result.records[0].serialSpecifications || "")

            this.processList = res.result.records[0].produceOrderTaskVo.map((item) => {
              return {
                label: item.processesName,
                key: item.processesName,
                value: item.processesId,
                taskId: item.taskId,
                planProduceNum: item.planProduceNum,
              }
            })
          }
        })
      }
    },

    changeScan4(v, opratorType) {
      // this.$toast('扫码进入')
      // 若扫到数字条码，则把数字条码回显到合格数框，多次扫数字条码则自动拼接。
      if (this.buildForm.qualifiedNum > 0) {
        let addStr = v.code + ""
        this.buildForm.qualifiedNum = this.buildForm.qualifiedNum + addStr
      } else {
        this.buildForm.qualifiedNum = v.code + ""
      }
      this.buildForm.qualifiedNum = this.buildForm.qualifiedNum.substring(0, 9) * 1
    },
    changeScan5(v, opratorType) {
      //用户二维码
      // 扫用户二维码，则把用户回显到操作人字段，扫一个用户二维码则回显一个，多个姓名之间用“，”隔开。
      // 若扫到重复的用户二维码则toast提示“该用户已存在”。
      let uid = v.code.userid
      let users = this.buildForm.userId.split(",")
      if (!users.includes(uid) && this.buildForm.userId) {
        // this.buildForm.userId = this.buildForm.userId + ',' + v.userid
        this.$refs.scanInput3.formData.key = uid
        this.$refs.scanInput3.formData.value = uid
        getAction("/sys/user/queryById", { id: uid }).then((res) => {
          if (res.code == 200) {
            this.realnameList.push(res.result.realname)
            this.userIdList.push(res.result.id)
            this.buildForm.userIdText = this.realnameList.join(",")
            this.buildForm.userId = this.userIdList.join(",")
            this.$forceUpdate()
          }
        })
      } else if (!users.includes(uid) && !this.buildForm.userId) {
        // this.buildForm.userId = v.userid
        getAction("/sys/user/queryById", { id: uid }).then((res) => {
          if (res.code == 200) {
            this.realnameList.push(res.result.realname)
            this.userIdList.push(res.result.id)
            this.buildForm.userIdText = this.realnameList.join(",")
            this.buildForm.userId = this.userIdList.join(",")
            this.$forceUpdate()
          }
        })
      } else {
        this.$toast("该用户已存在")
      }
    },

    // 扫任务码进入逻辑
    changeScan2(v, opratorType) {
      if (opratorType == "select" && this.buildForm.processesId != v.value) {
        this.buildForm.processesId = v.value
        this.buildForm.processesName = v.key || "-"
        this.buildForm.taskId = v.taskId
        this.buildForm.planProduceNum = v.planProduceNum
        scheduleById({ id: v.taskId }).then((res) => {
          if (res.code == 200) {
            this.buildForm.qualifiedNum = res.result.reportWorkNum > 0 ? res.result.reportWorkNum : 0
            this.reportWorkNum = res.result.reportWorkNum
            this.editTotal = 0
            this.buildForm.planNum = res.result.planNum
            this.$forceUpdate()
          }
        })
      }
      if (opratorType == "scan") {
        console.log(v.code, "v.code")
        if (v.code.EntityType !== "productTask") {
          this.$toast("请扫正确二维码")
          return
        }
        let obj = {
          id: v.code.id,
        }
        produceOrderReportWorkWorkbench(obj).then((res) => {
          if (res.code == 200) {
            if (res.result.orderStatus != 1) {
              this.$toast("工单状态不正确")
              return
            }

            this.$refs.scanInput.formData.value = res.result.orderId
            this.$refs.scanInput.formData.key = res.result.orderCode

            this.$refs.scanInput2.formData.value = res.result.processesId
            this.$refs.scanInput2.formData.key = res.result.processesName
            this.buildForm.planProduceNum = res.result.planProduceNum

            workOrderList({
              pageNo: 1,
              pageSize: 9999,
              orderCode: res.result.orderCode,
            }).then((res) => {
              if (res.code == 200) {
                this.buildForm.goodsName =
                  res.result.records[0].serialNumber +
                  " | " +
                  res.result.records[0].serialName +
                  " | " +
                  (res.result.records[0].serialSpecifications || "")
                this.$forceUpdate()
              }
            })

            this.buildForm.processesId = res.result.processesId
            this.buildForm.orderCode = res.result.orderCode
            this.buildForm.processesCode = res.result.processesCode
            this.buildForm.processesName = res.result.processesName
            this.buildForm.taskId = v.code.id

            this.$refs.scanInput.showPicker = true
            this.$refs.scanInput.showPicker = false
            this.$refs.scanInput2.showPicker = true
            this.$refs.scanInput2.showPicker = false

            scheduleById({ id: v.code.id }).then((res) => {
              if (res.code == 200) {
                this.buildForm.qualifiedNum = res.result.reportWorkNum > 0 ? res.result.reportWorkNum : 0
                this.editTotal = 0
                this.buildForm.planNum = res.result.planNum
                this.$forceUpdate()
              }
            })
          } else {
            Tips.error(res.message)
          }
        })
      }
    },
    changeScan3(v, opratorType) {
      if (opratorType == "scan") {
        console.log(v.code)
        if (v.code.EntityType !== "printTask") {
          this.$toast("请扫正确二维码")
          return
        }

        if (this.userIdScanList.indexOf(v.code.userid) !== -1) {
          this.$toast("该用户已存在")
          return
        } else {
          this.userIdScanList.push(v.code.userid)
        }

        getAction("/sys/user/queryById", { id: v.code.userid }).then((res) => {
          if (res.code == 200) {
            this.realnameList.push(res.result.realname)
            this.userIdList.push(res.result.id)
            this.buildForm.userIdText = this.realnameList.join(",")
            this.buildForm.userId = this.userIdList.join(",")
            this.$forceUpdate()
          }
        })
      }
    },
    fileChange(ids) {
      this.buildForm.attachment = ids
      console.log("父组件" + ids) //你要保存的fileids
    },
    // 提交
    btnConfirm(val, back) {
      if (val) {
        // 继续报工
        this.sequentially = true
      }
      if (!this.buildForm.orderCode) {
        this.$toast("请选择工单编号")
        return
      }
      if (!this.buildForm.processesId && !this.buildForm.processesName) {
        this.$toast("请选择工序")
        return
      }
      if (!this.buildForm.userId) {
        this.$toast("请选择操作人")
        return
      }
      if (!this.buildForm.qualifiedNum) {
        this.$toast("请输入合格数")
        return
      }
      if (!this.buildForm.unqualifiedNum) {
        this.$toast("请输入不合格数")
        return
      }
      if (Number(this.buildForm.unqualifiedNum) < 0) {
        this.$toast("不合格数不小于0")
        return
      }

      if (Number(this.buildForm.unqualifiedNum) + Number(this.buildForm.qualifiedNum) == 0) {
        this.$toast("合格数和不合格数不得同时为0")
        return
      }

      if (!this.buildForm.reportTime) {
        this.$toast("请选择报工时间")
        return
      }

      if (
        Number(this.buildForm.unqualifiedNum) + Number(this.buildForm.qualifiedNum) >
        Number(this.reportWorkNum) + Number(this.editTotal)
      ) {
        this.$toast("合格数+不合格数不能大于报工数量")
        return
      }

      // 校验自定义字段
      if (this.formTypeExtendedFields.length > 0) {
        let flag = true
        this.formTypeExtendedFields.forEach((item) => {
          if (item.fieldMust == 2 && !this.buildForm.extDataJson[item.fieldKey]) {
            flag = false
            this.$toast(item.fieldName + "为必填项")
            return
          }
        })
        if (!flag) {
          return
        }
      }

      this.handleSubmit(back)
    },
    handleSubmit(back) {
      let extendedFields = this.formTypeExtendedFields
      console.log(extendedFields, "formTypeExtendedFields")
      let extDataJson = this.buildForm.extDataJson
      this.formTypeExtendedFields.forEach((item) => {
        for (const itemKey in extDataJson) {
          if (item.fieldMust == 1) {
            this.buildForm.extDataJson[item.fieldKey] = item.placeholder
          }
        }
      })
      let params = {
        ...this.buildForm,
      }
      if (this.$route.query.type == "edit") {
        // 编辑
        produceOrderReportWorkEdit({
          ...params,
          id: this.$route.query.item.id,
        })
          .then((res) => {
            if (res.success) {
              this.$toast("编辑成功")
              if (back) {
                this.$router.back()
              }
              setTimeout(() => {
                if (!this.sequentially) {
                  this.$router.push({
                    path: "/productTask/report",
                  })
                } else {
                  this.buildForm.reportTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                  scheduleById({ id: this.buildForm.taskId }).then((res) => {
                    if (res.code == 200) {
                      this.buildForm.qualifiedNum = res.result.reportWorkNum > 0 ? res.result.reportWorkNum : 0
                      this.editTotal = 0
                      this.buildForm.planNum = res.result.planNum
                      this.$forceUpdate()
                    }
                  })
                }
              }, 500)
            } else {
              this.$toast(res.message)
            }
          })
          .finally(() => {
            this.subLoading = false
          })
      } else {
        // 新增
        productionReportingAdd(params)
          .then((res) => {
            if (res.success) {
              this.$toast("报工成功")
              if (back) {
                this.$router.back()
              }
              setTimeout(() => {
                if (!this.sequentially) {
                  this.$router.push({
                    path: "/productTask/report",
                  })
                } else {
                  this.buildForm.reportTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                  scheduleById({ id: this.buildForm.taskId }).then((res) => {
                    if (res.code == 200) {
                      this.buildForm.qualifiedNum = res.result.reportWorkNum > 0 ? res.result.reportWorkNum : 0
                      this.editTotal = 0
                      this.buildForm.planNum = res.result.planNum
                      this.$forceUpdate()
                    }
                  })
                }
              }, 500)
            } else {
              this.$toast(res.message)
            }
          })
          .finally(() => {
            this.subLoading = false
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/theme.scss";

.jiange-line {
  height: 20px;
  background-color: #f5f5f5;
}

.required span::after {
  left: -20px;
  top: 3px;
}

.search-content {
  position: fixed;
  top: 110px;
  width: 100%;
  height: calc(100vh - 180px);
  background: #fff;
  overflow: scroll;
  z-index: 99;
  padding-bottom: 50px;

  .formgroup {
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 20px;
    margin-bottom: 40px;
    padding-top: 20px;

    .title {
      width: 116px;
      height: 28px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 10px;
      margin-left: 32px;
    }
  }
}

.bottomLine {
  height: 2px;
  background-color: #f0f0f0;
  margin: 0 32px;
}

.otherText {
  padding-bottom: 32px;
  font-size: 32px;
  font-weight: bold;
  color: #191f25;
}

.haveUnitBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 32px;

  /deep/ .van-cell {
    padding-right: 0;
    width: 520px;
  }

  /deep/ .van-field__control {
    max-width: 600px;
  }
}

/deep/ .van-nav-bar {
  z-index: 99;
}

.search-bottoms {
  width: 100%;
  height: 100px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0.16rem;
  padding: 0 22px;
  box-sizing: border-box;
  font-size: 32px;
  font-weight: 500;
  z-index: 9;

  .btncancel {
    flex: 1;
    background: #f6f6f6;
    border: 2px solid rgba(25, 31, 37, 0.12);
    box-sizing: border-box;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    margin-right: 22px;
    color: #191f25;
  }

  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 79px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    color: #ffffff;
  }
}
</style>
